import React, { useEffect, useState } from 'react';
import { Clock } from 'lucide-react';
export function CountdownBar() {
  const [timeLeft, setTimeLeft] = useState(14 * 60 + 42); // 14:42 in seconds
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (seconds: number) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  };
  return <div className="fixed top-0 left-0 w-full bg-[#18181B] text-white py-4 z-50 shadow-lg text-center px-4 border-b border-white/10 overflow-hidden" data-id="element-45">
      <div className="absolute inset-0 bg-gradient-to-r from-emerald-900/20 via-transparent to-emerald-900/20 pointer-events-none" data-id="element-46"></div>

      <div className="relative z-10 flex items-center justify-center gap-3 font-medium text-sm md:text-base tracking-wide" data-id="element-47">
        <div className="relative flex h-3 w-3" data-id="element-48">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-rose-400 opacity-75" data-id="element-49"></span>
          <span className="relative inline-flex rounded-full h-3 w-3 bg-rose-500 shadow-[0_0_8px_rgba(244,63,94,0.6)]" data-id="element-50"></span>
        </div>

        <span className="text-gray-300 font-medium tracking-wide" data-id="element-51">
          OFERTA EXPIRA EN:
          <span className="text-amber-400 font-mono text-lg mx-2 font-bold tracking-wider drop-shadow-[0_0_5px_rgba(251,191,36,0.5)]" data-id="element-52">
            {formatTime(timeLeft)}
          </span>
        </span>

        <span className="hidden md:inline text-gray-600 mx-2" data-id="element-53">|</span>

        <span className="text-emerald-400 font-bold tracking-wide uppercase text-xs md:text-sm bg-emerald-950/50 px-3 py-1 rounded-full border border-emerald-500/30 shadow-[0_0_10px_rgba(16,185,129,0.2)]" data-id="element-54">
          SOLO QUEDAN 3 CUPOS
        </span>
      </div>
    </div>;
}